import { useState } from 'react'
import { Link } from 'react-router-dom'
import apiService from '../services/api'

const AuthForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setMessage('')
    setLoading(true)
    try {
      await apiService.post('/auth/forgot-password', { email })
      setMessage('Si un compte existe, un email a été envoyé.')
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur de demande')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
      <div className="card w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center">Mot de passe oublié</h1>
        {message && <p className="text-green-600 text-sm mb-3">{message}</p>}
        {error && <p className="text-red-600 text-sm mb-3">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
            <input type="email" className="input-field" value={email} onChange={e=>setEmail(e.target.value)} placeholder="email@exemple.com" />
          </div>
          <button type="submit" className="btn-primary w-full" disabled={loading}>{loading ? 'Envoi...' : 'Envoyer le lien de réinitialisation'}</button>
        </form>
        <p className="text-sm text-gray-600 mt-4 text-center">
          <Link to="/login" className="text-orange-600 hover:underline">Retour à la connexion</Link>
        </p>
      </div>
    </div>
  )
}

export default AuthForgotPassword



